// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnnouncementDraftController from "./announcement_draft_controller"
application.register("announcement-draft", AnnouncementDraftController)

import BulkDownloadController from "./bulk_download_controller"
application.register("bulk-download", BulkDownloadController)

import ContractPreviewController from "./contract_preview_controller"
application.register("contract-preview", ContractPreviewController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FabricReferenceController from "./fabric_reference_controller"
application.register("fabric-reference", FabricReferenceController)

import FieldDrawerController from "./field_drawer_controller"
application.register("field-drawer", FieldDrawerController)

import FieldFormController from "./field_form_controller"
application.register("field-form", FieldFormController)

import FormFieldsSortableController from "./form_fields_sortable_controller"
application.register("form-fields-sortable", FormFieldsSortableController)

import FormSubmissionAutosaveController from "./form_submission_autosave_controller"
application.register("form-submission-autosave", FormSubmissionAutosaveController)

import FormUploadController from "./form_upload_controller"
application.register("form-upload", FormUploadController)

import FormViewSlugController from "./form_view_slug_controller"
application.register("form-view-slug", FormViewSlugController)

import GrowerDirectoryController from "./grower_directory_controller"
application.register("grower-directory", GrowerDirectoryController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InvoiceFilterController from "./invoice_filter_controller"
application.register("invoice-filter", InvoiceFilterController)

import MemberFilterController from "./member_filter_controller"
application.register("member-filter", MemberFilterController)

import MessageComposerController from "./message_composer_controller"
application.register("message-composer", MessageComposerController)

import MessagesController from "./messages_controller"
application.register("messages", MessagesController)

import NotificationPrefsController from "./notification_prefs_controller"
application.register("notification-prefs", NotificationPrefsController)

import PlantFilterController from "./plant_filter_controller"
application.register("plant-filter", PlantFilterController)

import PushSubscriptionController from "./push_subscription_controller"
application.register("push-subscription", PushSubscriptionController)

import ScaleTicketController from "./scale_ticket_controller"
application.register("scale-ticket", ScaleTicketController)

import SubmitGateController from "./submit_gate_controller"
application.register("submit-gate", SubmitGateController)

import SupportController from "./support_controller"
application.register("support", SupportController)

import TableSearchController from "./table_search_controller"
application.register("table-search", TableSearchController)

import VendorSearchController from "./vendor_search_controller"
application.register("vendor-search", VendorSearchController)

import WorkflowBuilderController from "./workflow_builder_controller"
application.register("workflow-builder", WorkflowBuilderController)
